const alertStore = {
  icon: '',
  title: '',
  content: '',
  callback: () => {},
};

export default alertStore;
